// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".filtering__zero__view[data-v-1b7d7de0]{margin-top:3rem}", "",{"version":3,"sources":["webpack://./resources/becrop/assets/js/components/Common/ZeroView.vue"],"names":[],"mappings":"AACA,wCACI,eAAJ","sourcesContent":["\n.filtering__zero__view {\n    margin-top: 3rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
